import { useDispatch } from 'react-redux';
import readFile from 'utils/readFile';
import parseGpx from 'utils/parseGpx';
import parseRoute from 'utils/parseRoute';
import { GPX_UPLOAD, GPX_UPLOAD_ERROR, GPX_UPLOAD_SUCCESS } from './constants';
import { addError } from '../AlertService/actions';

function useGpxUpload() {
  const dispatch = useDispatch();
  return async function gpxUpload(file) {
    if (!file) {
      return;
    }
    dispatch({ type: GPX_UPLOAD, file });
    try {
      const content = await readFile(file);
      const data = parseGpx(content);
      const route = parseRoute(data);
      dispatch({ type: GPX_UPLOAD_SUCCESS, route });
    } catch (error) {
      dispatch(
        addError({ title: 'GPX Import Error', description: error.message }),
      );
      dispatch({ type: GPX_UPLOAD_ERROR, error });
    }
  };
}

export default useGpxUpload;
